<template>
  <div class="uikit_icon">
    <img :src="`/images/iconset/${name}.svg`" />
  </div>
</template>

<script>

export default {
  name: "uikitIcon",
  props: {
    name: {
      type: String,
      default: "Icon",
    },
  },
};
</script>

<style scoped>
.uikit_icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  padding: 4px;
}
</style>
